import { Alert, Box, Typography } from "@mui/material";
import { useAuiState } from "@assistant-ui/react";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { clearError } from "../store/slices/chatSlice";
import { ChatLoaderBar } from "../components/chat/ChatLoaderBar";

// Above-composer slot: stream/HTTP error from Redux + the shipped
// ChatLoaderBar (visible while assistant-ui's runtime reports running).
// Mirrors the legacy Chatbot.tsx composer-area block.
export function ChatComposerAbove() {
  const dispatch = useAppDispatch();
  const error = useAppSelector((s) => s.chat.error);
  const isRunning = useAuiState((s) => s.thread.isRunning);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, px: 2 }}>
      {error && (
        <Alert
          severity="error"
          onClose={() => dispatch(clearError())}
          sx={{ fontSize: "0.875rem" }}
        >
          {error}
        </Alert>
      )}
      <ChatLoaderBar visible={isRunning} />
    </Box>
  );
}

// Below-composer slot: privacy reminder. Static text — kept identical to
// the legacy chat so users see the same warning across both versions.
export function ChatComposerBelow() {
  return (
    <Typography
      variant="caption"
      sx={{
        color: "#888",
        fontSize: "0.75rem",
        mt: 1,
        textAlign: "center",
        display: "block",
      }}
    >
      Please don't share any private or confidential data
    </Typography>
  );
}
